'use client'

import { memo } from 'react'
import { CraftShell } from '../_components/craft-shell'
import { NinxlGovtsHeroBackground } from '../_components/ninxl-govts-hero-background'
import { NinxlGovtsSection } from '../_components/ninxl-govts-section'

/** baby: Govts keeps section content; craft shell replaces 8bit chrome. */
const NinxlGovtsPage = () => (
  <CraftShell>
    <NinxlGovtsHeroBackground />
    <main>
      <NinxlGovtsSection />
    </main>
  </CraftShell>
)

export default memo(NinxlGovtsPage)
